// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1zSqi","error":"Textarea_error__2HtNw","readonly":"Textarea_readonly__1p4Jl","disabled":"Textarea_disabled__25yW2"};